import { WoWCoordsToPixel, type MapContent, type MapPOI } from '../utils'
import { houseIconUrl } from './housingUi'
import styles from './HousingMap.module.scss'

type Props = {
  mapId: number
  neighborhood: MapContent
  plot: MapPOI
}

const PlotMinimap = ({ mapId, neighborhood, plot }: Props) => {
  const markerPosition = (() => {
    const plotPx = WoWCoordsToPixel(mapId, plot.X, plot.Y)
    const bbox1Px = WoWCoordsToPixel(
      mapId,
      neighborhood.BoundingBox.Item1.X,
      neighborhood.BoundingBox.Item1.Y,
    )
    const bbox2Px = WoWCoordsToPixel(
      mapId,
      neighborhood.BoundingBox.Item2.X,
      neighborhood.BoundingBox.Item2.Y,
    )

    const minPxX = Math.min(bbox1Px.x, bbox2Px.x)
    const maxPxX = Math.max(bbox1Px.x, bbox2Px.x)
    const minPxY = Math.min(bbox1Px.y, bbox2Px.y)
    const maxPxY = Math.max(bbox1Px.y, bbox2Px.y)

    return {
      left: `${((plotPx.x - minPxX) / (maxPxX - minPxX)) * 100}%`,
      top: `${((plotPx.y - minPxY) / (maxPxY - minPxY)) * 100}%`,
    }
  })()

  return (
    <div className={styles.plotMinimap}>
      <img
        src={neighborhood.ThumbnailURL}
        alt={`${neighborhood.Name} minimap`}
      />
      <img
        src={houseIconUrl}
        className={styles.plotMinimapMarker}
        style={markerPosition}
        alt='Plot location'
      />
    </div>
  )
}

export default PlotMinimap
